import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRuler = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M21.614,18.322l-3.292,3.292c-0.822,0.822 -2.154,0.822 -2.976,0l-12.789,-12.789c-0.821,-0.821 -0.821,-2.154 0,-2.975l3.292,-3.293c0.822,-0.821 2.154,-0.821 2.976,0l12.789,12.79c0.821,0.821 0.821,2.154 0,2.975Z",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.58px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.47,13.63l2.714,-2.714",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.58px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.326,7.486l2.714,-2.714",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.58px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.392,10.553l2.714,-2.714",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.58px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.447,16.608l2.714,-2.714",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.58px"
				}
			})
		]
	})
});
export default SvgRuler;
